import { authRoutes } from "./auth-routes";

export default (router: any) => {
  authRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
